import React, {Component} from 'react'
import {Message, Button} from 'semantic-ui-react'
import Utils from './../../modules/utils'
import './special-status-logs-message.css'

class QbSyncHoldLogs extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {

    }
  }

  dismiss() {
    if (window.confirm('Are you sure you want to dismiss QB sync logs?')) {
      Utils.get('dismiss_qb_sync_hold_logs', (err, res) =>
      {
        window.location.reload()
      })
    }
  }

  render() {
    let {qbSyncHoldLogs} = this.props.user

    if (qbSyncHoldLogs != null && qbSyncHoldLogs.length > 0) {
      const list = qbSyncHoldLogs.map((log) => {
        return log.refnumber + ' — ' + log.styleNumber + ' — quantity changed from ' + log.oldQuantity  + ' to ' + log.newQuantity + ' — ' + Utils.formatSimpleDate(log.createdAt)
      })

      return (
        <div style={{paddingBottom: '40px'}}>
          <Message
            className='special-status-logs-message'
            icon='cloud'
            header='You have holds that were synced with Quickbooks'
            list={list}
            onDismiss={this.dismiss}
            color='yellow'
          />
        </div>
      )
    } else {
      return null
    }
  }
}

export default QbSyncHoldLogs
